import { Box, Typography } from "@mui/material";
import check from "../../../assets/images/check.svg";
import cancel from "../../../assets/images/cancel.svg";
import Loader from "../../../components/Loader";

export default function ClaimSubmitResponse(props: any) {
  const { status, isLoading } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      px={2}
    >
      {isLoading ? <Loader isLoading={isLoading} /> : null}
      <Box display="flex" alignItems="center" justifyContent="center">
        <img
          src={status === "APPROVED" ? check : cancel}
          alt="Logo"
          style={{ height: 200, width: 200, objectFit: "contain" }}
        />
      </Box>
      <Typography fontSize={38} fontWeight={600} gutterBottom>
        {status === "APPROVED" ? "Claim Approved" : "Claim Rejected"}
      </Typography>
      <Typography fontSize={30} fontWeight={500} maxWidth={900} mb={4}>
        {status === "APPROVED"
          ? "We are pleased to inform you that your claim has been approved after successful verification of all submitted documents."
          : "Thank you for reviewing the claim."}
      </Typography>
    </Box>
  );
}
